import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  padding-top: 127px;
  .box-date {
    display: none;
  }
  .text-date {
    font-size: 18px;
    font-weight: 600;
    line-height: 27px;
  }
  span.btn {
    img {
      height: 24px;
      width: 24px;
    }
  }
  .icon-date {
    img {
      width: 24px;
      height: 24px;
    }
  }
  .box-top {
    position: fixed;
    z-index: 98;
    top: 138px;
    left: 0;
    right: 0;
    padding-right: 32px;
    padding-left: 32px;
    background-color: #f7f7f7;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    margin-top: 8px;
    margin-bottom: 16px;
  }
  .box-chart {
    height: auto;
    border-radius: 8px;
    padding: 20px 16px 24px 34px;
    margin-bottom: 16px;
    background-color: #ffffff;
    box-shadow: var(--box-shadow);
    .box-date-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .header-chart {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .box-button {
    display: flex;
    flex-direction: row;
    width: auto;
    height: 30px;
    .button-left-margin {
      margin-right: 16px;
    }
  }
  .example-spin {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
